/* ============================================================
   HOME · CATEGORY PORTALS PREMIUM — Kong Fitness MX
   JS vanilla, sin librerías. Multi-instancia.
   - Filtro por tabs (fade-out + scale, reflow del grid)
   - Animación de entrada con stagger (IntersectionObserver)
   - Ripple en tap (mobile)
   - Estado vacío del filtro
   - Integración con el editor de Shopify (section/block events)
   - Respeta prefers-reduced-motion y el toggle enable_animations
   ============================================================ */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -------- Inicializa una instancia de la sección -------- */
  function initSection(root) {
    if (!root || root.__hcpInit) return;
    root.__hcpInit = true;

    root.classList.add('hcp--js');

    var noMotion = root.classList.contains('hcp--no-motion') || prefersReduced;
    var grid = root.querySelector('.hcp__grid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.hcp__card'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.hcp__tab'));
    var empty = root.querySelector('.hcp__empty');

    /* ---------- CAPA 1: filtro por tabs ---------- */
    function applyFilter(filter) {
      var visible = 0;
      cards.forEach(function (card) {
        var group = card.getAttribute('data-group') || 'otro';
        // 'todos' (en una card) aparece en cualquier filtro.
        var match = filter === 'all' || group === filter || group === 'todos';
        if (match) {
          card.hidden = false;
          // forzar reflow antes de quitar is-out para que anime el fade-in
          void card.offsetWidth;
          card.classList.remove('is-out');
          visible++;
        } else {
          card.classList.add('is-out');
          if (noMotion) {
            card.hidden = true;
          } else {
            // ocultar del flujo tras la transición (reorganiza el grid)
            window.setTimeout(function () {
              if (card.classList.contains('is-out')) card.hidden = true;
            }, 320);
          }
        }
      });
      if (empty) empty.classList.toggle('is-visible', visible === 0);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        applyFilter(tab.getAttribute('data-filter') || 'all');
      });
    });

    /* ---------- Animación de entrada (stagger) ---------- */
    var entranceOn = root.classList.contains('hcp--entrance') && !noMotion;

    function revealAll() {
      var header = root.querySelector('.hcp__header');
      if (header) header.classList.add('is-in');
      cards.forEach(function (card, i) {
        card.style.transitionDelay = (i * 80) + 'ms';
        card.classList.add('is-in');
        // limpiar el delay tras animar para no afectar hover/filtro
        window.setTimeout(function () { card.style.transitionDelay = ''; }, i * 80 + 700);
      });
    }

    if (!entranceOn) {
      // sin animación: mostrar todo de inmediato
      var h = root.querySelector('.hcp__header');
      if (h) h.classList.add('is-in');
      cards.forEach(function (c) { c.classList.add('is-in'); });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            revealAll();
            obs.disconnect();
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      io.observe(grid || root);
    } else {
      revealAll();
    }

    /* ---------- Ripple en tap (mobile / pointer coarse) ---------- */
    if (!noMotion) {
      cards.forEach(function (card) {
        card.addEventListener('pointerdown', function (ev) {
          if (ev.pointerType === 'mouse') return; // solo touch/pen
          var rect = card.getBoundingClientRect();
          var size = Math.max(rect.width, rect.height);
          var rip = document.createElement('span');
          rip.className = 'hcp__ripple';
          rip.style.width = rip.style.height = size + 'px';
          rip.style.left = (ev.clientX - rect.left - size / 2) + 'px';
          rip.style.top = (ev.clientY - rect.top - size / 2) + 'px';
          card.appendChild(rip);
          window.setTimeout(function () { rip.remove(); }, 650);
        }, { passive: true });
      });
    }

    return {
      cards: cards,
      tabs: tabs,
      applyFilter: applyFilter
    };
  }

  /* -------- Bootstrap de todas las instancias -------- */
  function initAll() {
    var roots = document.querySelectorAll('.hcp[data-section-id]');
    Array.prototype.forEach.call(roots, function (r) { initSection(r); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ============================================================
     INTEGRACIÓN CON EL EDITOR DE SHOPIFY
     ============================================================ */
  function rootFromEvent(evt) {
    var id = evt && evt.detail && evt.detail.sectionId;
    if (!id) return null;
    return document.querySelector('.hcp[data-section-id="' + id + '"]');
  }

  // Sección cargada / recargada en el editor → re-init en vivo
  document.addEventListener('shopify:section:load', function (evt) {
    var root = rootFromEvent(evt);
    if (root) {
      root.__hcpInit = false;
      initSection(root);
    }
  });

  // Seleccionar una card en el editor → scroll suave + highlight temporal
  document.addEventListener('shopify:block:select', function (evt) {
    var blk = evt.target;
    if (!blk || !blk.classList || !blk.classList.contains('hcp__card')) return;
    blk.hidden = false;
    blk.classList.remove('is-out');
    blk.classList.add('is-editor-active');
    try {
      blk.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      blk.scrollIntoView();
    }
  });

  document.addEventListener('shopify:block:deselect', function (evt) {
    var blk = evt.target;
    if (blk && blk.classList) blk.classList.remove('is-editor-active');
  });
})();
